app.factory('Hr', ['$http', function ($http) {
    var factory = {};
    var baseUrl = 'hr';

    factory.getVacations = function (filter) {
        var status = filter.status;
        return $http.get(baseUrl + '/?status=' + status)
            .then(function (resp) {
                return resp.data;
            });
    };

    factory.addVacation = function (vacation) {
        if(vacation.status === 0 ) return $http.delete(baseUrl + '/vacation/'+ vacation._id); //delete
        else if (vacation._id) return $http.put(baseUrl + '/vacation', vacation); //edit
        else return $http.post(baseUrl + '/vacation', vacation); //add
    };

    factory.getCurrentVacation = function (profileId) {
        return $http.get(baseUrl + '/vacation/performer/'+ profileId).then(function (resp) {
            return resp.data;
        });
    };

    factory.getPositionHistory = function (params) {
        return $http.post( baseUrl + "/positionInfo/history", params).then(function (resp) {
            return resp.data;
        });
    };

    return factory;
}]);
